
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as flyhC6bb4svtTCnHTE8rHNcaXPR9w1p5qwBLzK9mlTmrQUMeta } from "/opt/render/project/src/pages/fly.vue?macro=true";
import { default as mapza3RKRqRdUTw0S87jC378e50WjwZQ0ctxQjFdqpSeJkMeta } from "/opt/render/project/src/pages/map.vue?macro=true";
import { default as helpnoT52crgYytw8L0FEXuYD7Xy6XN70ZeSE4PdDsayVNUMeta } from "/opt/render/project/src/pages/help.vue?macro=true";
import { default as news16gc_t1_ci3hMZqDtq5RIoNmU04ftYKaG7RBwGAt1fwMeta } from "/opt/render/project/src/pages/news.vue?macro=true";
import { default as indexOC_Okt6Gb3_dVbF2GXnGH_OSvVXRLhw23L3x7pjqOAIMeta } from "/opt/render/project/src/pages/index.vue?macro=true";
import { default as historye9yzCNmICaApg9Bcv_FnAqPyzaBQlpCzx3tTuJ4KsV8Meta } from "/opt/render/project/src/pages/history.vue?macro=true";
import { default as osgR1AnFyDzO37bdp5yRthHftgVGK6i82m7S3ZvDzzN3dAMeta } from "/opt/render/project/src/pages/admin/osg.vue?macro=true";
import { default as otgdBUiqEBO_451A71iftFsjPDPMdxd5sTaeDNnppSXRLW6EMeta } from "/opt/render/project/src/pages/admin/otg.vue?macro=true";
import { default as ew_45statuspBIchiDlK2n8apJ8dINNKiEMyjxLugjIhzLEUXCsTpAMeta } from "/opt/render/project/src/pages/ew-status.vue?macro=true";
import { default as ammoNt5xTMsLpJCMT4njm7UpHPiYRHogeu_opyZBw56TJ50Meta } from "/opt/render/project/src/pages/admin/ammo.vue?macro=true";
import { default as faqsp5_453YqCMH207GPmk9UKdjaD_45rVz0lpqVYEtvfPrQytYMeta } from "/opt/render/project/src/pages/admin/faqs.vue?macro=true";
import { default as newsQvGyHa4DMh8P84NR9F5Q6nVktbYpLZgiJCi_45ud9qP38Meta } from "/opt/render/project/src/pages/admin/news.vue?macro=true";
import { default as team_45stock_459d80ZNDgqY2cw5rSGWnBybDhWnFgns7iP7NyosLLJMMeta } from "/opt/render/project/src/pages/team-stock.vue?macro=true";
import { default as teams0Fl_45IOj8VHMFnRKQPZMFRu0vj8Yg55zMJwsbQuWchZ0Meta } from "/opt/render/project/src/pages/admin/teams.vue?macro=true";
import { default as usersecBLr_uRcrplQeKwFHIX7qiempz5h_45Vc_45j8wz4kwyfAMeta } from "/opt/render/project/src/pages/admin/users.vue?macro=true";
import { default as zonessViI4WIO1uAM_45xXZq79yzLVFO54C7kjkXCQ0yM0t2T0Meta } from "/opt/render/project/src/pages/admin/zones.vue?macro=true";
import { default as dronesHGSPrAbZNoH4lnnFjYvn8gkQsToNVyN5NXH52stUWXEMeta } from "/opt/render/project/src/pages/admin/drones.vue?macro=true";
import { default as mergert9_3qYl0uGsPbb8fOOcMnNvgx0s8dsH_E2UVuXBBvksMeta } from "/opt/render/project/src/pages/admin/merger.vue?macro=true";
import { default as notificationsZLhMJCwCV3FV6pszh798ys9ku3VktYV6blFh4aVJT6EMeta } from "/opt/render/project/src/pages/notifications.vue?macro=true";
import { default as signalkvnXwi6qQ5wPA_456nOq_45vMx_hhZfCKlNevfTgpaa3BgwMeta } from "/opt/render/project/src/pages/system/signal.vue?macro=true";
import { default as team_45settingsLkc6MslqZ07LKCWZOtK55bmofr6k1A5nEHOy2aKuAIwMeta } from "/opt/render/project/src/pages/team-settings.vue?macro=true";
import { default as brigadesfJB8wSQf_45nM70yDdnR9uGit4QIDo9XucKvc2tdKBeE8Meta } from "/opt/render/project/src/pages/admin/brigades.vue?macro=true";
import { default as sessionsJphQOxC2cBwsKYwOErkHkDSksdrJ2OQUqXdDXbTBi9QMeta } from "/opt/render/project/src/pages/admin/sessions.vue?macro=true";
import { default as _91channel_935DBIOWMR3HHBJ5KgAG0OlsA51h3ylAWPQcvIhRr4W_wMeta } from "/opt/render/project/src/pages/chat/[channel].vue?macro=true";
import { default as elementLzIDKsUidmOvxufNsWbFbFYTKGgWbSbPCs_H35fnArUMeta } from "/opt/render/project/src/pages/system/element.vue?macro=true";
import { default as weather_NzMEsLe3uv0tG_SZ_45grhcI35JcplS4QROQ_45BHvWbw0Meta } from "/opt/render/project/src/pages/system/weather.vue?macro=true";
import { default as divisionscCQUnUwW2R6lL72tyc7Tkofw6Wru5uAoACoavG4FcecMeta } from "/opt/render/project/src/pages/admin/divisions.vue?macro=true";
import { default as positionsc3sJFScQ50ymjghQYVgEDP3kIXdgOrwuN5wYlGh8SB4Meta } from "/opt/render/project/src/pages/admin/positions.vue?macro=true";
import { default as wind_45labAqYtuDyf8TTOppCpCYRTRejJldXezS_458wslgrkEz3BMMeta } from "/opt/render/project/src/pages/system/wind-lab.vue?macro=true";
import { default as account_45settingsGi_CR1LBrr7LhsKupHjMDRbYN41Q6xesXUJgNzB6RXkMeta } from "/opt/render/project/src/pages/account-settings.vue?macro=true";
import { default as ammunitionzLSsQ1uvBRyqF7_Lw9pIoUqFQXd5VhFxljTF6k8XrZMMeta } from "/opt/render/project/src/pages/admin/ammunition.vue?macro=true";
import { default as indexxCwtmKoLGwgsYBoMLLIJZSJPJONBOGEpKjGYjS_45BjtMMeta } from "/opt/render/project/src/pages/uav-flight/index.vue?macro=true";
import { default as uav_45crew_45settingsiOv_wEBkuHWVe7_45AaP_45ALFUpdSmWaatskYg2zQkT3WUMeta } from "/opt/render/project/src/pages/uav-crew-settings.vue?macro=true";
import { default as activefxfakKX_lRM5reqDAxJnwL5z146x8ma6Y2GDHhTGh0AMeta } from "/opt/render/project/src/pages/zone-admin/active.vue?macro=true";
import { default as missionsDWiFHX8_45fNSP50jFJwwWZU7YukBgdIdnEcikmXQgZEIMeta } from "/opt/render/project/src/pages/analytics/missions.vue?macro=true";
import { default as permissions5r7RmuwCd5LlT0xal3iAMHyRA6YLq8rqT7EnRgfaBnUMeta } from "/opt/render/project/src/pages/system/permissions.vue?macro=true";
import { default as read_45stores9ATK0sq46zhpvD6H2MOv_R5jc3vI_dErG4pKofZDVi0Meta } from "/opt/render/project/src/pages/system/read-stores.vue?macro=true";
import { default as indexpQJ7Yntt2UANobUzCtf5eRQSP8nYSDqZlNo9Rcw2QtoMeta } from "/opt/render/project/src/pages/uav-dispatch/index.vue?macro=true";
import { default as historyA0OwErWwpE5gAsYj8OaDp_45O_wWKCWKXvGFS62AYwSNkMeta } from "/opt/render/project/src/pages/uav-flight/history.vue?macro=true";
import { default as chat_channelsyqxibKfYSaSRtigFBhq_45mqecg3QTMkLrAVFQWTou7FoMeta } from "/opt/render/project/src/pages/admin/chat_channels.vue?macro=true";
import { default as uav_45platformsSF1WVtSq4tSVZotmDjmIJeZXEhpC5Mock_45OCJuY6ZNsMeta } from "/opt/render/project/src/pages/admin/uav-platforms.vue?macro=true";
import { default as inactivezG7sE7ypAocZ_45t7l5iSGddBb0hGnZzY1XouQujVMtBsMeta } from "/opt/render/project/src/pages/zone-admin/inactive.vue?macro=true";
import { default as directionsXZpfH6weMwANNaQ0gYw26aIu3zWC4g2VZ90ZbPVKOdsMeta } from "/opt/render/project/src/pages/analytics/directions.vue?macro=true";
import { default as uav_45parse_45labUiEY8MRuS6xStzgK0s32BlleP_eo7twp_6iUHUtPClcMeta } from "/opt/render/project/src/pages/system/uav-parse-lab.vue?macro=true";
import { default as history5vpnG0kSmbbZq_45oyb1qkjJIYCF_45az2Pt6zo0Ck0Dnu4Meta } from "/opt/render/project/src/pages/uav-dispatch/history.vue?macro=true";
import { default as broadcastEZNHjDjSuKZEYW_45tMZGgsx2vp3432DJO8gr4D_45Y6nOkMeta } from "/opt/render/project/src/pages/zone-admin/broadcast.vue?macro=true";
import { default as signalLSzx_45BppSV9vuTXLs6TfV9ry4IF9lPjGpw7k1zGDSo4Meta } from "/opt/render/project/src/pages/division-admin/signal.vue?macro=true";
import { default as targetsCVDRF_1VK6TXrpLqK7OxDDksKzuYHJ_45X657NzAs0mw8Meta } from "/opt/render/project/src/pages/division-admin/targets.vue?macro=true";
import { default as daily_45resultsHDerReJh_AYQsHKZ7iGWL89o8wgRcTkC7yTiwjh7KboMeta } from "/opt/render/project/src/pages/analytics/daily-results.vue?macro=true";
import { default as sessionsUwibC5jTU7AHRYVuCfpahlLhsuZFTiL4_tIPPbyYLi4Meta } from "/opt/render/project/src/pages/division-admin/sessions.vue?macro=true";
import { default as _91id_93LBV3Hmtlyqg7pFUUlGdWLb3RI0zhDuUNq0WvtIg8ob4Meta } from "/opt/render/project/src/pages/uav-flight/mission/[id].vue?macro=true";
import { default as inventoryr8dnYID_zvsB02SbXLLRHoYJn4zYtqPhc_z3h5ey8r0Meta } from "/opt/render/project/src/pages/division-admin/inventory.vue?macro=true";
import { default as channel_45heatmapoki62Ne3kEpCKsNDgdi_455kgFeHhIrDqgUeVOg_45izzeAMeta } from "/opt/render/project/src/pages/analytics/channel-heatmap.vue?macro=true";
import { default as zone_45requestsVFEW9dxqPXtvq0PTpa1rvXOKbf5_45T0nuhaysOYW1XUYMeta } from "/opt/render/project/src/pages/division-admin/zone-requests.vue?macro=true";
export default [
  {
    name: "fly",
    path: "/fly",
    component: () => import("/opt/render/project/src/pages/fly.vue")
  },
  {
    name: "map",
    path: "/map",
    meta: mapza3RKRqRdUTw0S87jC378e50WjwZQ0ctxQjFdqpSeJkMeta || {},
    component: () => import("/opt/render/project/src/pages/map.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/opt/render/project/src/pages/help.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/opt/render/project/src/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexOC_Okt6Gb3_dVbF2GXnGH_OSvVXRLhw23L3x7pjqOAIMeta || {},
    component: () => import("/opt/render/project/src/pages/index.vue")
  },
  {
    name: "history",
    path: "/history",
    meta: historye9yzCNmICaApg9Bcv_FnAqPyzaBQlpCzx3tTuJ4KsV8Meta || {},
    component: () => import("/opt/render/project/src/pages/history.vue")
  },
  {
    name: "admin-osg",
    path: "/admin/osg",
    component: () => import("/opt/render/project/src/pages/admin/osg.vue")
  },
  {
    name: "admin-otg",
    path: "/admin/otg",
    component: () => import("/opt/render/project/src/pages/admin/otg.vue")
  },
  {
    name: "ew-status",
    path: "/ew-status",
    meta: ew_45statuspBIchiDlK2n8apJ8dINNKiEMyjxLugjIhzLEUXCsTpAMeta || {},
    component: () => import("/opt/render/project/src/pages/ew-status.vue")
  },
  {
    name: "admin-ammo",
    path: "/admin/ammo",
    component: () => import("/opt/render/project/src/pages/admin/ammo.vue")
  },
  {
    name: "admin-faqs",
    path: "/admin/faqs",
    component: () => import("/opt/render/project/src/pages/admin/faqs.vue")
  },
  {
    name: "admin-news",
    path: "/admin/news",
    component: () => import("/opt/render/project/src/pages/admin/news.vue")
  },
  {
    name: "team-stock",
    path: "/team-stock",
    meta: team_45stock_459d80ZNDgqY2cw5rSGWnBybDhWnFgns7iP7NyosLLJMMeta || {},
    component: () => import("/opt/render/project/src/pages/team-stock.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    component: () => import("/opt/render/project/src/pages/admin/teams.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: usersecBLr_uRcrplQeKwFHIX7qiempz5h_45Vc_45j8wz4kwyfAMeta || {},
    component: () => import("/opt/render/project/src/pages/admin/users.vue")
  },
  {
    name: "admin-zones",
    path: "/admin/zones",
    component: () => import("/opt/render/project/src/pages/admin/zones.vue")
  },
  {
    name: "admin-drones",
    path: "/admin/drones",
    component: () => import("/opt/render/project/src/pages/admin/drones.vue")
  },
  {
    name: "admin-merger",
    path: "/admin/merger",
    component: () => import("/opt/render/project/src/pages/admin/merger.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/opt/render/project/src/pages/notifications.vue")
  },
  {
    name: "system-signal",
    path: "/system/signal",
    component: () => import("/opt/render/project/src/pages/system/signal.vue")
  },
  {
    name: "team-settings",
    path: "/team-settings",
    component: () => import("/opt/render/project/src/pages/team-settings.vue")
  },
  {
    name: "admin-brigades",
    path: "/admin/brigades",
    component: () => import("/opt/render/project/src/pages/admin/brigades.vue")
  },
  {
    name: "admin-sessions",
    path: "/admin/sessions",
    meta: sessionsJphQOxC2cBwsKYwOErkHkDSksdrJ2OQUqXdDXbTBi9QMeta || {},
    component: () => import("/opt/render/project/src/pages/admin/sessions.vue")
  },
  {
    name: "chat-channel",
    path: "/chat/:channel()",
    meta: _91channel_935DBIOWMR3HHBJ5KgAG0OlsA51h3ylAWPQcvIhRr4W_wMeta || {},
    component: () => import("/opt/render/project/src/pages/chat/[channel].vue")
  },
  {
    name: "system-element",
    path: "/system/element",
    component: () => import("/opt/render/project/src/pages/system/element.vue")
  },
  {
    name: "system-weather",
    path: "/system/weather",
    meta: weather_NzMEsLe3uv0tG_SZ_45grhcI35JcplS4QROQ_45BHvWbw0Meta || {},
    component: () => import("/opt/render/project/src/pages/system/weather.vue")
  },
  {
    name: "admin-divisions",
    path: "/admin/divisions",
    component: () => import("/opt/render/project/src/pages/admin/divisions.vue")
  },
  {
    name: "admin-positions",
    path: "/admin/positions",
    component: () => import("/opt/render/project/src/pages/admin/positions.vue")
  },
  {
    name: "system-wind-lab",
    path: "/system/wind-lab",
    meta: wind_45labAqYtuDyf8TTOppCpCYRTRejJldXezS_458wslgrkEz3BMMeta || {},
    component: () => import("/opt/render/project/src/pages/system/wind-lab.vue")
  },
  {
    name: "account-settings",
    path: "/account-settings",
    component: () => import("/opt/render/project/src/pages/account-settings.vue")
  },
  {
    name: "admin-ammunition",
    path: "/admin/ammunition",
    component: () => import("/opt/render/project/src/pages/admin/ammunition.vue")
  },
  {
    name: "uav-flight",
    path: "/uav-flight",
    meta: indexxCwtmKoLGwgsYBoMLLIJZSJPJONBOGEpKjGYjS_45BjtMMeta || {},
    component: () => import("/opt/render/project/src/pages/uav-flight/index.vue")
  },
  {
    name: "uav-crew-settings",
    path: "/uav-crew-settings",
    component: () => import("/opt/render/project/src/pages/uav-crew-settings.vue")
  },
  {
    name: "zone-admin-active",
    path: "/zone-admin/active",
    component: () => import("/opt/render/project/src/pages/zone-admin/active.vue")
  },
  {
    name: "analytics-missions",
    path: "/analytics/missions",
    meta: missionsDWiFHX8_45fNSP50jFJwwWZU7YukBgdIdnEcikmXQgZEIMeta || {},
    component: () => import("/opt/render/project/src/pages/analytics/missions.vue")
  },
  {
    name: "system-permissions",
    path: "/system/permissions",
    meta: permissions5r7RmuwCd5LlT0xal3iAMHyRA6YLq8rqT7EnRgfaBnUMeta || {},
    component: () => import("/opt/render/project/src/pages/system/permissions.vue")
  },
  {
    name: "system-read-stores",
    path: "/system/read-stores",
    meta: read_45stores9ATK0sq46zhpvD6H2MOv_R5jc3vI_dErG4pKofZDVi0Meta || {},
    component: () => import("/opt/render/project/src/pages/system/read-stores.vue")
  },
  {
    name: "uav-dispatch",
    path: "/uav-dispatch",
    meta: indexpQJ7Yntt2UANobUzCtf5eRQSP8nYSDqZlNo9Rcw2QtoMeta || {},
    component: () => import("/opt/render/project/src/pages/uav-dispatch/index.vue")
  },
  {
    name: "uav-flight-history",
    path: "/uav-flight/history",
    component: () => import("/opt/render/project/src/pages/uav-flight/history.vue")
  },
  {
    name: "admin-chat_channels",
    path: "/admin/chat_channels",
    component: () => import("/opt/render/project/src/pages/admin/chat_channels.vue")
  },
  {
    name: "admin-uav-platforms",
    path: "/admin/uav-platforms",
    meta: uav_45platformsSF1WVtSq4tSVZotmDjmIJeZXEhpC5Mock_45OCJuY6ZNsMeta || {},
    component: () => import("/opt/render/project/src/pages/admin/uav-platforms.vue")
  },
  {
    name: "zone-admin-inactive",
    path: "/zone-admin/inactive",
    component: () => import("/opt/render/project/src/pages/zone-admin/inactive.vue")
  },
  {
    name: "analytics-directions",
    path: "/analytics/directions",
    meta: directionsXZpfH6weMwANNaQ0gYw26aIu3zWC4g2VZ90ZbPVKOdsMeta || {},
    component: () => import("/opt/render/project/src/pages/analytics/directions.vue")
  },
  {
    name: "system-uav-parse-lab",
    path: "/system/uav-parse-lab",
    meta: uav_45parse_45labUiEY8MRuS6xStzgK0s32BlleP_eo7twp_6iUHUtPClcMeta || {},
    component: () => import("/opt/render/project/src/pages/system/uav-parse-lab.vue")
  },
  {
    name: "uav-dispatch-history",
    path: "/uav-dispatch/history",
    component: () => import("/opt/render/project/src/pages/uav-dispatch/history.vue")
  },
  {
    name: "zone-admin-broadcast",
    path: "/zone-admin/broadcast",
    component: () => import("/opt/render/project/src/pages/zone-admin/broadcast.vue")
  },
  {
    name: "division-admin-signal",
    path: "/division-admin/signal",
    component: () => import("/opt/render/project/src/pages/division-admin/signal.vue")
  },
  {
    name: "division-admin-targets",
    path: "/division-admin/targets",
    component: () => import("/opt/render/project/src/pages/division-admin/targets.vue")
  },
  {
    name: "analytics-daily-results",
    path: "/analytics/daily-results",
    meta: daily_45resultsHDerReJh_AYQsHKZ7iGWL89o8wgRcTkC7yTiwjh7KboMeta || {},
    component: () => import("/opt/render/project/src/pages/analytics/daily-results.vue")
  },
  {
    name: "division-admin-sessions",
    path: "/division-admin/sessions",
    component: () => import("/opt/render/project/src/pages/division-admin/sessions.vue")
  },
  {
    name: "uav-flight-mission-id",
    path: "/uav-flight/mission/:id()",
    meta: _91id_93LBV3Hmtlyqg7pFUUlGdWLb3RI0zhDuUNq0WvtIg8ob4Meta || {},
    component: () => import("/opt/render/project/src/pages/uav-flight/mission/[id].vue")
  },
  {
    name: "division-admin-inventory",
    path: "/division-admin/inventory",
    component: () => import("/opt/render/project/src/pages/division-admin/inventory.vue")
  },
  {
    name: "analytics-channel-heatmap",
    path: "/analytics/channel-heatmap",
    meta: channel_45heatmapoki62Ne3kEpCKsNDgdi_455kgFeHhIrDqgUeVOg_45izzeAMeta || {},
    component: () => import("/opt/render/project/src/pages/analytics/channel-heatmap.vue")
  },
  {
    name: "division-admin-zone-requests",
    path: "/division-admin/zone-requests",
    component: () => import("/opt/render/project/src/pages/division-admin/zone-requests.vue")
  }
]